import { mixed, object, string } from 'yup'
import type { User } from '@/prisma/client'

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})/

export function loginSchema(fields: string[], t: Function) {
  const baseSchema = {
    email: string().email(t('errors.email')).required(t('errors.required')),
    password: string().required(t('errors.required')),
  }
  const partialSchema: Record<string, any> = {}
  fields.forEach((fieldName) => {
    if (fieldName in baseSchema) {
      partialSchema[fieldName] = baseSchema[fieldName as keyof typeof baseSchema]
    }
  })
  return object(partialSchema)
}

export function userSchema(fields: string[], t: Function) {
  const baseSchema = {
    name: string().required(t('errors.required')),
    surname: string().required(t('errors.required')),
    phone: string().required(t('errors.required')),
    email: string().email(t('errors.email')).required(t('errors.required')),
    password: string().matches(passwordRegex, t('errors.password')).required(t('errors.required')),
    privacy: mixed().oneOf([true], t('errors.required')).required(t('errors.required')),
  }
  const partialSchema: Record<string, any> = {}
  fields.forEach((fieldName) => {
    if (fieldName in baseSchema) {
      partialSchema[fieldName] = baseSchema[fieldName as keyof typeof baseSchema]
    }
  })
  return object(partialSchema)
}

export const useUserStore = defineStore('user', () => {
  const data = ref()
  const autoUpdateClient = ref(false)
  async function create(user: Partial<User>, ref?: string) {
    try {
      const result = await $fetch<User | null>('/api/public/user', {
        method: 'POST',
        body: { ...user, ref },
      })
      if (result) data.value = result
      return { data: result, status: 'success', error: null }
    } catch (e) {
      return { data: null, status: 'error', error: e.data }
    }
  }
  async function update(user: Partial<User>) {
    try {
      const result = await $fetch<User | null>('/api/user', {
        method: 'PUT',
        body: user,
      })
      if (result) data.value = result
      return { data: result, status: 'success', error: null }
    } catch (e) {
      return { data: null, status: 'error', error: e.data }
    }
  }
  async function onboardingCompleted() {
    try {
      const result = await $fetch<User | null>('/api/onboarding-completed', {
        method: 'PUT',
      })
      if (result) data.value = result
      return { data: result, status: 'success', error: null }
    } catch (e) {
      return { data: null, status: 'error', error: e.data }
    }
  }
  const requestPasswordReset = async (email: string) => {
    try {
      const result = await $fetch('/api/public/user/password-reset', {
        method: 'PUT',
        body: { email },
      })
      return { data: result, status: 'success', error: null }
    } catch (e) {
      return { data: null, status: 'error', error: e.data }
    }
  }
  const resetPassword = async (token: string, newPassword: string) => {
    try {
      const result = await $fetch('/api/public/user/password-reset', {
        method: 'POST',
        body: { token, newPassword },
      })
      return { data: result, status: 'success', error: null }
    } catch (e) {
      p
      return { data: null, status: 'error', error: e.data }
    }
  }
  return {
    create, update, onboardingCompleted,
    requestPasswordReset, resetPassword,
    data,
    autoUpdateClient,
  }
})